import { useState, useEffect, useCallback } from "react";

export const useMasterData = ({ FinancierYear, masterGroup, CompanyID, API_ENDPOINTS, showError,mastersLoaded, setMastersLoaded }) => {
    const [masterDataLoading, setMasterDataLoading] = useState(false);
    const [dataTransporter, setDataTransporter] = useState([]);
    const [dataSupplier, setDataSupplier] = useState([]);
    const [dataManufacturer, setDataManufacturer] = useState([]);
    const [dataPricelist, setDataPricelist] = useState([]);
    const [dataCustomer, setDataCustomer] = useState([]);
    const [dataShipmentmode, setDataShipmentmode] = useState([]);
    const [dataPaymentterm, setDataPaymentterm] = useState([]);
    const [dataCreditterm, setDataCreditterm] = useState([]);
    const [dataCredittermRule, setDataCredittermRule] = useState([]);
    // const [isDataLoading, setIsDataLoading] = useState(false);

    const loadMasterData = useCallback(async () => {
        setMasterDataLoading(true);
        try {
            const requestBody = { FinancierYear, masterGroup, CompanyID };
            const response = await fetch(API_ENDPOINTS.FIND_ALL_MASTER_DATA, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestBody),
            });

            if (!response.ok) throw new Error("Unable to fetch master data");

            const data = await response.json();

            if (data && data.length > 0) {
                let rawString = data[0].master_data;
                let result = {};

                try {
                    result = typeof rawString === "string" ? JSON.parse(rawString) : rawString;

                    setDataTransporter(result.PARTY || []);
                    setDataSupplier(result.PARTY || []);
                    setDataManufacturer(result.PRODUCT_GROUP || []);
                    setDataPricelist(result.PRICE_LIST || []);
                    setDataCustomer(result.PARTY || []);
                    setDataShipmentmode(result.SHIPMENT_MODE || []);
                    setDataPaymentterm(result.PAYMENT_TERM || []);
                    setDataCreditterm(result.CREDIT_TERM || []);
                    setDataCredittermRule(result.CREDIT_TERM_RULE || []);
                    setMastersLoaded(true);
                    showError("Master data loaded successfully", "success");
                } catch (err) {
                    console.error("❌ JSON parse error:", err, rawString);
                    showError("Invalid master data format", "error");
                }
            } else {
                showError("No master data found", "warning");
            }
        } catch (error) {
            console.error("❌ Fetch error:", error);
            showError("Unable to load master data!", "error");
        } finally {
            setMasterDataLoading(false);
        }
    }, [FinancierYear, masterGroup, CompanyID, API_ENDPOINTS, showError]);

    // Auto-load once on mount
    useEffect(() => {
        if (!mastersLoaded) {
            loadMasterData();
        }
    }, [loadMasterData]);

    return {
        masterDataLoading,
        dataTransporter,
        dataSupplier,
        dataManufacturer,
        dataPricelist,
        dataCustomer,
        dataShipmentmode,
        dataPaymentterm,
        dataCreditterm,
        dataCredittermRule,
        reload: loadMasterData, // expose reload for manual trigger
    };
};


